import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Inject,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatToolbar } from '@angular/material/toolbar';
import { type IIntegration } from '@principle-theorem/integrations';
import {
  ButtonsContainerComponent,
  DialogPresets,
  IIntegrationDialogData,
} from '@principle-theorem/ng-shared';
import { type Observable } from 'rxjs';
import {
  type IMedipassIntegrationData,
  MedipassIntegrationStorage,
} from '../integration/integration-storage';
import {
  type IMedipassFormData,
  MedipassIntegrationFormComponent,
} from '../medipass-integration-form/medipass-integration-form.component';
import {
  type IMedipassConfigProvider,
  NG_MEDIPASS_CONFIG_PROVIDER,
} from '../ng-medipass-config';

@Component({
  selector: 'pr-manage-medipass-integration',
  templateUrl: './manage-medipass-integration.component.html',
  styleUrls: ['./manage-medipass-integration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatButton,
    MatToolbar,
    MatDialogModule,
    ButtonsContainerComponent,
  ],
})
export class ManageMedipassIntegrationComponent {
  private _storage: MedipassIntegrationStorage =
    new MedipassIntegrationStorage();
  private _data =
    inject<IIntegrationDialogData<IMedipassIntegrationData>>(MAT_DIALOG_DATA);
  integration$: Observable<IIntegration<IMedipassIntegrationData> | undefined>;

  constructor(
    @Inject(NG_MEDIPASS_CONFIG_PROVIDER)
    public config: IMedipassConfigProvider,
    private _dialog: MatDialog
  ) {
    this.integration$ = this._storage.get$(this._data.integrationsCol);
  }

  async removeIntegration(): Promise<void> {
    await this._storage.remove(this._data.integrationsCol);
  }

  async addIntegration(): Promise<void> {
    const data = await this._dialog
      .open<MedipassIntegrationFormComponent, undefined, IMedipassFormData>(
        MedipassIntegrationFormComponent,
        DialogPresets.medium()
      )
      .afterClosed()
      .toPromise();

    if (!data) {
      return;
    }
    await this._storageAdd(data);
  }

  private async _storageAdd(data: IMedipassIntegrationData): Promise<void> {
    await this._storage.add(this._data.integrationsCol, data);
  }
}
